type MinimizedModal = {
  key?: string;
  title?: string;
  label?: string;
};

const LABELS_BY_KEY: Record<string, string> = {
  "Dashboard-Account-Settings": "My account",
  "Dashboard-Clients-Business": "Clients",
  "Dashboard-ClientAdd-Business": "Create client",
  "Dashboard-Jobs-Business": "Jobs",
  "Dashboard-JobsAdd-Business-Without-Quote-all": "Create job",
  "Dashboard-QuoteAdd-Business": "Create quote",
  "Dashboard-QuotesAdd-Business": "Create quote",
  "Dashboard-Quotes-Business": "See Quotes",
  "Dashboard-Invoices-See": "Invoices",
  "Dashboard-Invoices-Create": "Create invoice",
  "Dashboard-JobsCalendar-Business": "Calendar",
  "Dashboard-Jobs-Calendar": "Calendar",
  "Dashboard-Connections-Business": "Connections",
  "Dashboard-Providers-Business": "Providers",
  "Dashboard-Calculator-Business": "Calculator",
  "Dashboard-Workforces-List": "Workforces",
  "Dashboard-Workforce-Create": "Create workforce",
  "Dashboard-InvoiceCreate-Business": "Create invoice",
  "Organization-CoverageAreas-Business": "Coverage areas",
  "Organization-ManageServices-Business": "Services",
  "Organization-ManageHours-Business": "Hours",
  "Organization-PasswordVault-Business": "Password vault",
  "Organization-TimeZone-Business": "Time zone",
  "Organization-PhoneNumbers": "Phone numbers",
  "Privacy-policy": "Privacy policy",
  "Terms-Service-Modal": "Terms of service",
  "Help-Modal": "Help",
};

const humanizeKey = (key?: string) => {
  if (!key) return "Modal";

  const jobMatch = key.match(/(?:^|-)JobCard-(\d+)$/);
  if (jobMatch) return `Job #${jobMatch[1]}`;

  const quoteMatch = key.match(/(?:QuoteRow-ViewQuote|Quote)-(\d+)/);
  if (quoteMatch) return `Quote #${quoteMatch[1]}`;

  const invoiceDetailsMatch = key.match(/^Dashboard-Invoice-Details-(.+)$/);
  if (invoiceDetailsMatch) return `Invoice — ${invoiceDetailsMatch[1].slice(0, 12)}`;

  const invoiceMatch = key.match(/(?:^|-)Invoice-(.+)$/);
  if (invoiceMatch) return `Invoice — ${invoiceMatch[1].slice(0, 12)}`;

  return key
    .replace(/[-_]+/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase())
    .trim();
};

const getDetailModalLabel = (modal: MinimizedModal) => {
  const key = modal.key ?? "";

  const quoteMatch = key.match(/(?:QuoteRow-ViewQuote|Quote)-(\d+)/);
  if (quoteMatch) return `Quote #${quoteMatch[1]}`;

  const jobMatch = key.match(/(?:^|-)JobCard-(\d+)$/);
  if (jobMatch) return `Job #${jobMatch[1]}`;

  const workforceMatch = key.match(/^Workforce-Portfolio-Details-(.+)$/);
  if (workforceMatch) {
    const title = modal.title || modal.label;
    if (title && /^workforce\s+—\s+/i.test(title)) return title;
    if (title && !/^(workforce details|see|view|workforce)\b/i.test(title)) return `Workforce — ${title}`;

    return `Workforce ${workforceMatch[1].slice(0, 12)}`;
  }

  if (key.startsWith("Dashboard-Invoice-Details")) {
    const title = modal.title || modal.label;
    if (title && !/^(see|view)\s+/i.test(title)) return title;

    const invoiceDetailsMatch = key.match(/^Dashboard-Invoice-Details-(.+)$/);
    if (invoiceDetailsMatch) return `Invoice — ${invoiceDetailsMatch[1].slice(0, 12)}`;
  }

  return null;
};

export const getMinimizedModalLabel = (modal: MinimizedModal) =>
  getDetailModalLabel(modal) || modal.title || modal.label || LABELS_BY_KEY[modal.key ?? ""] || humanizeKey(modal.key);
